import { Servers } from '@constants/server';
import { Tenant } from 'TenantModule/types';
import { postApiGalaxyServer } from 'services';
import { Realm } from 'types';

export interface CreateDumpFileForSingleDbPayload {
  realmId: Realm['realm_id'];
  tenantName: Tenant['tenantName'];
  serviceName: Servers;
  /** One or more team IDs to dump, all within the same realm. */
  teamIds: number[];
}

export type CreateDumpFileForSingleDbSuccessResponse = {
  tenantName: string;
  realmId: string;
  teamIds?: string[];
  fileName: string;
  url: string;
};

export interface CreateDumpFileForSingleDbErrorResponse {
  error: string;
  message: string;
  statusCode: number;
}

export const createDumpFileForSingleDB = ({
  params: body,
  token,
  config = {},
}: BaseApiParams<CreateDumpFileForSingleDbPayload>) =>
  postApiGalaxyServer(`/database/createDumpFileForSingleDB`, body, config, token);
